import { FunctionComponent, useState } from "react";
import { AriaMenuStatus, Boundary, informationNotice, MenuAriaModel, Notice, Select, Table, TextOption } from "@pjs/core-ui";
import { userUiI18n } from "../i18n/UserUiI18n.const";
import { NotificationRow } from "./NotificationRow.component";
import { INotificationsProps } from "./interfaces/INotificationsProps";
import "./styles/notifications.css";

export const Notifications: FunctionComponent<INotificationsProps> = (props) => {
    const frequencySelectId = "frequencySelect";
    const timeSelectId = "timeSelect";

    const [frequencyModel, setFrequencyModel] = useState<MenuAriaModel>({
        type: AriaMenuStatus.Closed,
        isOpen: false,
        activeItemIndex: props.model.digestSettings.frequency.index
    });

    const [timeModel, setTimeModel] = useState<MenuAriaModel>({
        type: AriaMenuStatus.Closed,
        isOpen: false,
        activeItemIndex: props.model.digestSettings.time.index
    });

    const onFrequencyModelChange = (newModel: MenuAriaModel): void => {
        if (newModel.activeItemIndex !== frequencyModel.activeItemIndex) {
            const setting = { ...props.model.digestSettings.frequency };
            setting.index = newModel.activeItemIndex;
            props.actions.updateNotificationFrequency(setting);
        }

        setFrequencyModel(newModel);
    };

    const onTimeModelChange = (newModel: MenuAriaModel): void => {
        if (newModel.activeItemIndex !== timeModel.activeItemIndex) {
            const setting = { ...props.model.digestSettings.time };
            setting.index = newModel.activeItemIndex;
            props.actions.updateNotificationTime(setting);
        }

        setTimeModel(newModel);
    };

    return (
        <Boundary>
            <Table>
                <Table.Header>
                    <Table.HeaderCell>{userUiI18n.getString("notifications.table_headers.event")}</Table.HeaderCell>
                    <Table.HeaderCell>
                        <div className="uui-notification-table__header-wrapper">{userUiI18n.getString("notifications.table_headers.email")}</div>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                        <div className="uui-notification-table__header-wrapper">{userUiI18n.getString("notifications.table_headers.digest")}</div>
                    </Table.HeaderCell>
                </Table.Header>
                <Table.Body>
                    {props.model.notificationSettings.map((notification) => {
                        return (
                            <Table.Row key={notification.title}>
                                <NotificationRow notification={notification} updateNotification={props.actions.updateNotification} />
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>

            <h3 className="uui-notifications-digest__title">{userUiI18n.getString("notifications.digest_settings.title")}</h3>
            <p className="uui-notifications-digest__description">{userUiI18n.getString("notifications.digest_settings.description")}</p>

            <div className="uui-notifications-digest__dropdown-wrapper">
                <div className="uui-notifications-digest__dropdown">
                    <span className="util-hide-element" id={frequencySelectId} aria-hidden="true">
                        {userUiI18n.getString("notifications.digest_settings.frequency_dropdown_label")}
                    </span>
                    <Select
                        model={frequencyModel}
                        onModelChange={onFrequencyModelChange}
                        dataSet={props.model.digestSettings.frequency.options}
                        labelId={frequencySelectId}
                        renderOption={TextOption}
                    />
                </div>
                <div className="uui-notifications-digest__dropdown">
                    <span className="util-hide-element" id={timeSelectId} aria-hidden="true">
                        {userUiI18n.getString("notifications.digest_settings.time_dropdown_label")}
                    </span>
                    <Select
                        model={timeModel}
                        onModelChange={onTimeModelChange}
                        dataSet={props.model.digestSettings.time.options}
                        labelId={timeSelectId}
                        renderOption={TextOption}
                    />
                </div>
            </div>

            <div className="uui-notifications-digest__disabled">
                {props.model.digestIsDisabled && (
                    <Notice ariaLabel="Label" type={informationNotice}>
                        {userUiI18n.getString("notifications.digest_settings.disabled_warning")}
                    </Notice>
                )}
            </div>
        </Boundary>
    );
};
